export default "__VITE_ASSET__2bbc96bd__"